import React, { useEffect, useState, useRef, useCallback } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import clsx from "clsx";
import {
  createTransaction,
  exchangeRate,
  fetchAccountUsage,
  getCurrencies,
  getPreferredCurrency
} from "../../../utils/Api";
import { ToastProvider, useToast } from "../../common/RemitAssureToast";
import { commaRemover, commaSeperator } from "../../../utils/hook";
import { useNavigate } from "react-router";
import { Button, Modal } from "react-bootstrap";
import debounce from "lodash.debounce";

const AmountDetail = ({ handleStep, step, previous }) => {
  const [loader, setLoader] = useState(false);
  const [tier_data, setTierData] = useState({
    count: "N/A",
    limit: "N/A",
    is_unlimited: false,
  });
  const [warning, setWarning] = useState({ toggle: false, message: "" });
  const navigate = useNavigate();
  const [maxAmount, setmaxAmount] = useState(30000);
  const [exch_rate, setExchRate] = useState("");
  const [amt_detail, setAmtDetail] = useState({
    send_amt: "",
    exchange_amt: "",
    from_type: "AUD",
    to_type: "NGN",
    recieve_meth: "Bank Transfer",
  });
  const isCalculatingRef = useRef(false);
  const [curr_out, setCurrOut] = useState([]);
  const [curr_in, setCurrIn] = useState([]);
  const [defaultExchange, setDefaultExchange] = useState("");
  const [toCountry, setToCountry] = useState("Nigeria");
const {showToast}=useToast()
const [currencyLoaded, setCurrencyLoaded] = useState(false);
  const amtSchema = Yup.object().shape({
    send_amt: Yup.string("Please enter a valid amount")
      .notOneOf([".", ""])
      .test("value-test", (value, validationcontext) => {
        const { createError } = validationcontext;
        const numericValue = Number(commaRemover(value));
        // if (numericValue < 100) {
        //   return createError({ message: "Minimum $100 required" });
        // }
        if (numericValue > 30000) {
          return createError({
            message: `Maximum transaction limit is $30,000`,
          });
        }
        return true;
      })
      .required("Amount Send is required"),
    exchange_amt: Yup.string("Please enter a valid amount")
      .notOneOf([".", ""])
      .required(),
    from_type: Yup.string().required(),
    to_type: Yup.string().required(),
  });
  const debouncedExchange = useRef(
    debounce(
      (
        value,
        direction,
        fromType,
        toType,
        formikSetFieldValue,
        formikSetFieldTouched,
        formikSetFieldError,
      ) => {
                console.log("⏱️ Debounce fired after 500ms, value:", value);
        if (!value || value === "" || value === ".") {
          setLoader(false);
          isCalculatingRef.current = false;
          return;
        }

        const numericValue = Number(commaRemover(value));

        if (
          direction === "From" &&
          // (numericValue < 100 || numericValue > 30000)
          numericValue > 30000
        ) {
          setLoader(false);
          isCalculatingRef.current = false;
          return;
        }

        isCalculatingRef.current = true;
                setLoader(true);
        console.log("🚀 API call starting, showing loader");

        exchangeRate({
          amount: commaRemover(value),
          from: fromType,
          to: toType,
          direction: direction,
        })
          .then(function (response) {
            let data = commaSeperator(response.amount);

            if (direction === "From") {
              formikSetFieldValue("exchange_amt", data);
              formikSetFieldTouched("exchange_amt", true);
              formikSetFieldError("exchange_amt", false);
              setDefaultExchange(response?.default_exchange);
            } else {
              const calculatedAmount = Number(commaRemover(data));
              const maxLimit = response.max_send_amount
                ? Number(commaRemover(response.max_send_amount))
                : 30000;

              if (calculatedAmount > maxLimit) {
                formikSetFieldError(
                  "exchange_amt",
                  `Maximum transaction limit is ${commaSeperator(
                    maxLimit.toString(),
                  )}`,
                );
                formikSetFieldTouched("exchange_amt", true);

              showToast('info', 'Limit Reached', `The exchange amount you entered would require sending more than the maximum limit of ${commaSeperator(maxLimit.toString())}`);
                setLoader(false);
                isCalculatingRef.current = false;
                return;
              }

              formikSetFieldValue("send_amt", data);
              formikSetFieldTouched("send_amt", true);
              formikSetFieldError("send_amt", "");
            }
            console.log("✅ API responded, hiding loader");

            setLoader(false);
            isCalculatingRef.current = false;
            setExchRate(response.rate);
          })
          .catch(function (error) {
            console.error("❌ API Error:", error);
            setLoader(false);
            isCalculatingRef.current = false;
          });
      },
      1500,
    ),
  ).current;

  useEffect(() => {
    return () => {
      debouncedExchange.cancel();
    };
  }, []);

  const initialValues = {
    send_amt: "",
    exchange_amt: "",
    from_type: "AUD",
    to_type: "NGN",
    recieve_meth: "Bank Transfer",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: amtSchema,
    validateOnChange: true,
    validateOnBlur: false,

    onSubmit: async (values) => {
      debouncedExchange.cancel();

      const cleaned = values.send_amt.replace(/,/g, "");
      const numericValue = Number(cleaned);

      if (numericValue > 30000) {
  showToast('info', 'Limit', "Maximum transaction limit is $30,000");
  return;
}
      setLoader(true);

      try {
        let local = {};
        let transaction_id = sessionStorage.getItem("transaction_id") || null;

        let payload = {
          transaction_id,
          amount: {
            send_amount: commaRemover(values.send_amt),
            receive_amount: commaRemover(values.exchange_amt),
            send_currency: values.from_type,
            receive_currency: values.to_type,
            receive_method: "Bank transfer",
            payout_partner: previous?.payout_part || "",
            reason: previous?.reason || "none",
            exchange_rate: exch_rate,
          },
        };

        if (!transaction_id || transaction_id === "undefined") {
          delete payload.transaction_id;
        }

        let amt = values.send_amt.includes(".")
          ? values.send_amt
          : values.send_amt + ".00";

        const trans_res = await createTransaction(payload);
        setLoader(false);

        if (trans_res.code === "200") {
          sessionStorage.setItem(
            "transaction_id",
            trans_res.data.transaction_id,
          );

          if (sessionStorage.getItem("transfer_data")) {
            local = JSON.parse(sessionStorage.getItem("transfer_data"));
          }

          local.amount = {
            ...values,
            send_amt: commaRemover(amt),
            exchange_amt: commaRemover(values.exchange_amt),
            exchange_rate: exch_rate,
            defaultExchange: defaultExchange,
          };

          sessionStorage.setItem("transfer_data", JSON.stringify(local));

          sessionStorage.removeItem("send-step");
          sessionStorage.setItem("send-step", Number(step) + 1);
          handleStep(Number(step) + 1);
    } else if (trans_res.code === "400") {
  showToast('error', 'Error', trans_res.message);
}
      } catch (error) {
        console.error("Exchange error:", error);
showToast('error', 'Error', "Something went wrong");
        setLoader(false);
      }
    },
  });
  const inputvalidation = (event) => {
    let data = event.target.value;
    const fieldName = event.target.name;

    if (data.length > 0) {
      if (data.includes(",")) {
        data = data.replace(/,/g, "");
      }

      if (/^\d*\.?\d{0,2}$/.test(data)) {
        const numericValue = parseFloat(data);

        if (fieldName === "send_amt" && numericValue > 30000) {
      showToast('info', 'Limit', "Maximum transaction limit is $30,000");

          return;
        }

        const [integerPart, decimalPart] = data.split(".");
        const formattedIntegerPart = integerPart.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ",",
        );

        data =
          decimalPart !== undefined
            ? `${formattedIntegerPart}.${decimalPart}`
            : formattedIntegerPart;

        formik.setFieldValue(fieldName, data);
        formik.setFieldTouched(fieldName, true);
        setAmtDetail({ ...amt_detail, [fieldName]: data });
        if (
          fieldName === "send_amt" &&
          // numericValue >= 100 &&
          numericValue > 0 &&
          numericValue <= 30000
        ) {
                    console.log("⌨️ Keystroke detected, debounce timer reset, value:", data);

          debouncedExchange(
            data,
            "From",
            formik.values.from_type,
            formik.values.to_type,
            formik.setFieldValue,
            formik.setFieldTouched,
            formik.setFieldError,
          );
        } else if (fieldName === "exchange_amt" && numericValue > 0) {
                    console.log("⌨️ Keystroke detected on exchange_amt, debounce timer reset, value:", data);

          debouncedExchange(
            data,
            "To",
            formik.values.from_type,
            formik.values.to_type,
            formik.setFieldValue,
            formik.setFieldTouched,
            formik.setFieldError,
          );
        } else {
          debouncedExchange.cancel();
          setLoader(false);
        }
      }
    } else {
      debouncedExchange.cancel();
      setLoader(false);

      formik.setFieldValue(fieldName, "");

      // Clear the other field when empty
      if (fieldName === "send_amt") {
        formik.setFieldValue("exchange_amt", "");
        setAmtDetail({ ...amt_detail, send_amt: "", exchange_amt: "" });
      } else if (fieldName === "exchange_amt") {
        formik.setFieldValue("send_amt", "");
        setAmtDetail({ ...amt_detail, send_amt: "", exchange_amt: "" });
      }
    }
  };

  const myTotalAmountTo = (e) => {
    setAmtDetail({ ...amt_detail, to_type: e.target.value });
    formik.setFieldValue("to_type", e.target.value);
    formik.setFieldTouched("to_type", true);

    const amt = commaRemover(
      formik.values.send_amt != undefined &&
        formik.values.send_amt != 0 &&
        formik.values.send_amt != ""
        ? formik.values.send_amt
        : "1",
    );

    // Always fetch exchange rate when currency changes
    setLoader(true);
    exchangeRate({
      amount: amt,
      from: formik.values.from_type,
      to: e.target.value,
      direction: "From",
    })
      .then(function (response) {
        setExchRate(response.rate);
        setDefaultExchange(response?.default_exchange);

        // Only update exchange_amt if user has entered a send_amt
        if (formik.values.send_amt && formik.values.send_amt !== "") {
          formik.setFieldValue("exchange_amt", commaSeperator(response.amount));
          setAmtDetail({
            ...amt_detail,
            exchange_amt: commaSeperator(response.amount),
          });
        }
        setLoader(false);
      })
      .catch(function (error) {
        console.error("API Error:", error);
        setLoader(false);
      });
  };
  const handleCancel = () => {
    sessionStorage.removeItem("transfer_data");
    sessionStorage.removeItem("send-step");
    navigate("/dashboard");
  };

  const handleRecieveMethod = (e) => {
    if (e.target.value === "Mobile Wallet") {
    showToast('warning', 'Unavailable', "This service option is currently unavailable");

      setAmtDetail({ ...amt_detail, recieve_meth: "Bank Transfer" });
      formik.setFieldValue("recieve_meth", "Bank Transfer");
    } else {
      setAmtDetail({ ...amt_detail, recieve_meth: e.target.value });
      formik.setFieldValue("recieve_meth", e.target.value);
    }
  };

  useEffect(() => {
   
    fetchAccountUsage().then((res) => {
      if (res.code === "200") {
        setTierData({
          count:
            res?.data?.transactions_left !== null
              ? res?.data?.transactions_left?.toString()
              : "N/A",
          limit:
            res?.data?.amount_left !== null
              ? res?.data?.amount_left?.toString()
              : "N/A",
          is_unlimited: res?.data?.unlimited,
        });
      }
    });
getPreferredCurrency().then((res) => {
  if (
    sessionStorage.getItem("conversion_data") ||
    sessionStorage.getItem("transfer_data")
  ) {
    setCurrencyLoaded(true);
    return;
  }

  if (res.code === "200") {
    const defaultTo = res?.data?.destination_currency || "USD";
    const defaultFrom = res?.data?.source_currency || "AUD";

    setAmtDetail((prev) => ({
      ...prev,
      to_type: defaultTo,
      from_type: defaultFrom,
    }));

    formik.setFieldValue("to_type", defaultTo);
    formik.setFieldValue("from_type", defaultFrom);

    setLoader(true);
    exchangeRate({
      amount: "1",
      from: defaultFrom,
      to: defaultTo,
      direction: "From",
    })
      .then((response) => {
        setExchRate(response.rate);
        setDefaultExchange(response?.default_exchange);
        setLoader(false);
      })
      .catch(() => setLoader(false));
  }

  setCurrencyLoaded(true);
});
    getCurrencies().then((res) => {
      if (res?.code === "200") {
        const apiMax = res?.data?.max_send_amount.replace(/[^0-9]/g, "");
        setmaxAmount(Math.min(30000, Number(apiMax) || 30000));
        setCurrOut(() => {
          return res?.data?.payout_currencies?.map((cr) => ({
            label: cr.country,
            value: cr.currency,
          }));
        });
        setCurrIn(() => {
          return res?.data?.payin_currencies?.map((cr) => cr.currency);
        });
      }
    });
  }, []);

  useEffect(() => {
      if (!currencyLoaded) return; // ✅ STOP early
    if (previous !== null && !sessionStorage.getItem("transfer_data")) {
      exchangeRate({
        amount: previous?.amount,
        from: previous?.send_currency,
        to: previous?.receive_currency,
        direction: "From",
      }).then((res) => {
        setAmtDetail({
          send_amt: commaSeperator(previous?.amount),
          from_type: previous?.send_currency,
          exchange_amt: commaSeperator(res?.amount),
          to_type: previous?.receive_currency,
          recieve_meth: previous?.recieve_meth || "Bank Transfer",
        });
        formik.setValues({
          send_amt: commaSeperator(previous?.amount),
          from_type: previous?.send_currency,
          exchange_amt: commaSeperator(res?.amount),
          to_type: previous?.receive_currency,
          recieve_meth: previous?.recieve_meth || "Bank Transfer",
        });
        setExchRate(res?.rate);
        setDefaultExchange(res?.default_exchange);
      });
    } else if (sessionStorage.getItem("transfer_data")) {
      let tdata = JSON.parse(sessionStorage.getItem("transfer_data"));
      if (tdata?.amount) {
        setAmtDetail({
          ...tdata?.amount,
          send_amt: commaSeperator(tdata.amount.send_amt),
          exchange_amt: commaSeperator(tdata.amount.exchange_amt),
          recieve_meth: tdata?.amount?.recieve_meth || "Bank Transfer",
        });
        formik.setValues({
          ...tdata?.amount,
          send_amt: commaSeperator(tdata.amount.send_amt),
          exchange_amt: commaSeperator(tdata.amount.exchange_amt),
          recieve_meth: tdata?.amount?.recieve_meth || "Bank Transfer",
        });
        setExchRate(tdata?.amount?.exchange_rate);
        setDefaultExchange(tdata?.amount?.defaultExchange);
        if (curr_out.length > 0) {
          const selected = curr_out.find(
            (opt) => opt.value === tdata?.amount?.to_type,
          );
          if (selected) {
            setToCountry(selected.label);
          }
        }
      }
    } else if (sessionStorage.getItem("conversion_data")) {
      let cdata = JSON.parse(sessionStorage.getItem("conversion_data"));

      if (cdata?.amount) {
        const amountData = {
          send_amt: cdata.amount.send_amt
            ? commaSeperator(cdata.amount.send_amt.toString())
            : "",
          exchange_amt: cdata.amount.exchange_amt
            ? commaSeperator(cdata.amount.exchange_amt.toString())
            : "",
          from_type: cdata.amount.from_type,
          to_type: cdata.amount.to_type,
          recieve_meth: cdata.amount.recieve_meth || "Bank Transfer",
        };
        setAmtDetail(amountData);
        formik.setValues(amountData);
        setExchRate(cdata.amount.exchange_rate || "");
        setDefaultExchange(cdata.amount.defaultExchange || "");
        sessionStorage.setItem("transfer_data", JSON.stringify(cdata));

        if (curr_out.length > 0) {
          const selected = curr_out.find(
            (opt) => opt.value === cdata.amount.to_type,
          );
          if (selected) {
            setToCountry(selected.label);
          }
        }
      }
     } else {
}
  }, [previous, curr_out,currencyLoaded]);

  useEffect(() => {
    if (formik.values.send_amt && formik.values.exchange_amt) {
      // if (Number(commaRemover(formik.values.send_amt)) >= 100) {
      if (Number(commaRemover(formik.values.send_amt)) > 0) {
        formik.setErrors({
          ...formik.errors,
          exchange_amt: undefined,
          send_amt: undefined,
        });
      } else {
        // formik.setFieldError("send_amt", "Minimum $100 is required.");
      }
    }
    if (formik.values.to_type && curr_out.length > 0) {
      const selected = curr_out.find(
        (opt) => opt.value === formik.values.to_type,
      );
      if (selected) {
        setToCountry(selected.label);
      }
    }
  }, [formik.values]);
if (!currencyLoaded) {
  return null; // or you can return a loader here
}

  return (
    <>
      <section>
        <div className="form-head mb-4">
          <h2 className="text-black font-w600 mb-0">
            <b>Amount & Delivery</b>
          </h2>
        </div>
        <form noValidate autoComplete="off" className="pb-5">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="input_field rate-value">
                    <p className="get-text Exchange_rate">Exchange Rate</p>
<p className="exchange-rate exchange_value">
  {exch_rate ? (
    <>
      1 <span>{formik.values.from_type}</span> ={" "}
      {commaSeperator(exch_rate)}{" "}
      <span>{formik.values.to_type}</span>
    </>
  ) : (
    <span className="d-flex align-items-center">
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
      ></span>
      Fetching rate...
    </span>
  )}
</p>
                  </div>
                </div>
              </div>
              <div className="row each-row">
                <div className="col-md-6">
                  <div className="input_field">
                    <p className="get-text">
                      From<span style={{ color: "red" }}>*</span>
                    </p>
                    <select
                      aria-label="Select a reason"
                      onChange={(e) => {
                        const newFromType = e.target.value;
                        formik.setFieldValue("from_type", newFromType);
                        formik.setFieldTouched("from_type", true);
                        setAmtDetail({ ...amt_detail, from_type: newFromType });

                        // Fetch new exchange rate when currency changes
                        setLoader(true);
                        exchangeRate({
                          amount: "1",
                          from: newFromType,
                          to: formik.values.to_type,
                          direction: "From",
                        })
                          .then(function (response) {
                            setExchRate(response.rate);
                            setDefaultExchange(response?.default_exchange);
                            setLoader(false);

                            // If there's an amount entered, recalculate it
                            if (
                              formik.values.send_amt &&
                              formik.values.send_amt !== ""
                            ) {
                              formik.setFieldValue("exchange_amt", "");
                              debouncedExchange(
                                formik.values.send_amt,
                                "From",
                                newFromType,
                                formik.values.to_type,
                                formik.setFieldValue,
                                formik.setFieldTouched,
                                formik.setFieldError,
                              );
                            }
                          })
                          .catch(function (error) {
                            console.error("API Error:", error);
                            setLoader(false);
                          });
                      }}
                      value={formik.values.from_type}
                      className="mb-3 bg-transparent form-control form-select rate_input"
                    >
                      {curr_in.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input_field">
                    <p className="get-text">
                      To<span style={{ color: "red" }}>*</span>
                    </p>
                    <select
                      aria-label="Select a reason"
                      className="mb-3 bg-transparent form-control form-select rate_input"
                      onChange={(e) => {
                        myTotalAmountTo(e);
                      }}
                      value={formik.values.to_type}
                    >
                      {curr_out.map((item, index) => {
                        return (
                          <option key={index} value={item.value}>
                            {item.value}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row each-row">
                <div className="col-md-6">
                  <div className="input_field">
                    <p className="get-text">
                      Amount to Send<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="send_amt"
                      value={formik.values?.send_amt}
                      onChange={(e) => {
                        inputvalidation(e);
                      }}
                      className={clsx(
                        `mb-3 bg-transparent form-control rate-input ${
                          formik.values.send_amt === "1"
                            ? "text-secondary lead"
                            : ""
                        }`,
                        {
                          "is-invalid":
                            formik.touched.send_amt && formik.errors.send_amt,
                        },
                        {
                          "is-valid":
                            formik.touched.send_amt && !formik.errors.send_amt,
                        },
                      )}
                      placeholder="100"
                    />
                    {formik.touched.send_amt && formik.errors.send_amt && (
                      <div className="fv-plugins-message-container mt-1">
                        <div className="fv-help-block">
                          <span
                            role="alert"
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {formik.errors.send_amt}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input_field">
                    <p className="get-text">Exchange Amount</p>
                    <input
                      type="text"
                      name="exchange_amt"
                      value={formik.values?.exchange_amt}
                      onChange={(e) => inputvalidation(e)}
                      className={clsx(
                        `mb-3 bg-transparent form-control rate-input ${
                          formik.values.send_amt === "1"
                            ? "text-secondary lead"
                            : ""
                        }`,
                        {
                          "is-invalid":
                            formik.touched.exchange_amt &&
                            formik.errors.exchange_amt,
                        },
                        {
                          "is-valid":
                            formik.touched.exchange_amt &&
                            !formik.errors.exchange_amt,
                        },
                      )}
                      placeholder={
                        defaultExchange !== "" && undefined
                          ? commaSeperator(defaultExchange)
                          : defaultExchange
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row each-row">
                <div className="col-md-12">
                  <h5>Receive Method</h5>
                  <div className="col-md-12">
                    <label className="container-new">
                      <span className="radio-tick">Bank Transfer</span>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="recivedMethod"
                        value="Bank Transfer"
                        checked={amt_detail.recieve_meth == "Bank Transfer"}
                        onChange={(e) => {
                          handleRecieveMethod(e);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  <div className="col-md-12">
                    <label className="container-new">
                      <span className="radio-tick">
                        Mobile Wallet{" "}
                        <span className="small text-muted">(coming soon)</span>
                      </span>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="recivedMethod"
                        value="Mobile Wallet"
                        checked={amt_detail.recieve_meth == "Mobile Wallet"}
                        onChange={(e) => {
                          handleRecieveMethod(e);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <button
                    type="button"
                    className="start-form-button full-col"
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-md-8 full-col">
                  <button
                    type="button"
                    onClick={async () => {
                      if (loader) {
                        return;
                      }
                      const isPending =
                        debouncedExchange.pending &&
                        debouncedExchange.pending();

                      if (debouncedExchange.flush) {
                        debouncedExchange.flush();
                      }
                      if (isCalculatingRef.current) {
                        let waitCount = 0;
                        while (isCalculatingRef.current && waitCount < 20) {
                          await new Promise((resolve) =>
                            setTimeout(resolve, 100),
                          );
                          waitCount++;
                        }
                      }

                      const errors = await formik.validateForm();

                      if (Object.keys(errors).length > 0) {
                        formik.setTouched({
                          send_amt: true,
                          exchange_amt: true,
                          from_type: true,
                          to_type: true,
                        });
                        return;
                      }

                      const sendAmt = commaRemover(formik.values.send_amt);
                      const numericValue = Number(sendAmt);

                      // if (numericValue < 100 || numericValue > 30000) {
                      if (numericValue <= 0 || numericValue > 30000) {
                        return;
                      }

                      debouncedExchange.cancel();
                      formik.handleSubmit();
                    }}
                    className="form-button full-col"
                  >
                    Continue
                    {loader ? (
                      <>
                        <div className="loader-overly">
                          <div className="loader"></div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
      <WarningModal
        show={warning.toggle}
        content={warning.message}
        onHide={() => {
          setWarning({ toggle: false, message: "" });
        }}
      />
    </>
  );
};

const WarningModal = ({ show, content, onHide }) => {
  const navigate = useNavigate();

  const submit = () => {
    navigate("/user-profile");
  };

  return (
    <>
      <Modal backdrop={"static"} show={show} centered onHide={onHide}>
        <Modal.Header closeButton>Transaction limit exceed</Modal.Header>
        <Modal.Body className="mb-5 mt-3">
          <div>{content}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="click" variant="primary" onClick={() => submit()}>
            Upgrade
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AmountDetail;